
import React, {useEffect} from "react";

import {
  Card,
  Col,
  Row,
  Typography, Skeleton
} from "antd";

// import LineChart from "../components/chart/LineChart";
import Reports from "../logic/reports";
import { useSelector } from 'react-redux';


function Home(props) {
  const overview = useSelector((state) => state.overview);

  const { Title } = Typography;

  const count = [
    {value: 'total_members', title: "Total customers", size: 6},
    {value: 'today_customers', title: "Today's customers", size: 6},
    {value: 'airtel_customers', title: 'No. Airtel Customers', size: 6},
    {value: 'mtn_customers', title: 'No. Mtn Customers', size: 6},

    {value: 'total_groups', title: 'Total Groups', size: 6},
    {value: 'pending_groups', title: "Pending Groups", size: 6},
    {value: 'inactive_groups', title: 'Inactive Groups', size: 6},
    {value: 'active_groups', title: 'Active Groups',  size: 6},
    
    {value: 'successful_deposits', title: 'No. Successful Deposits', size: 5},
    {value: 'total_deposit_amount', title: 'Amt. Successful Deposits', size: 7},
    {value: 'successful_withdraws', title: 'No. Successful Withdraws', size: 5},
    {value: 'total_withdraw_amount', title: 'Amt. Successful Withdraws', size: 7},
    
    {value: 'total_accounts', title: "No. Accounts", size: 6},
    {value: 'account_balances', title: "Account Balances", size: 6},
    {value: 'available_balances', title: "Amount Withdrawable", size: 6},
    {value: 'current_disan_balance', title: "Current Disan Balance", size: 6},
  ];


  useEffect(() => {
    document.title = "DiSAN Admin";
    new Reports(props, {}).getDashboard()
  }, [props]);

  return (
    <>
      <div className="layout-content">
        {
          overview.fetching ? 
          <Skeleton active /> :
          <Row className="rowgap-vbox" gutter={[24, 0]}>
          {count.map((c, index) => (
            <Col
              key={index}
              xs={24}
              sm={24}
              md={12}
              lg={c.size}
              xl={c.size}
              className="mb-24"
            >
              <Card 
                bordered={false}
                className="criclebox">
                <div className="number">
                  <Row align="middle" gutter={[24, 0]}>
                    <Col xs={24}>
                      <Title level={4}>
                        {Number(overview.details.data[c.value]).toLocaleString()}
                      </Title>
                      <span style={{color: 'black', fontWeight: 5}}>{c.title}</span>
                      
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
        }
        


        {/* <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
            <Card bordered={false} className="criclebox h-full">
              <LineChart />
            </Card>
          </Col>
        </Row> */}

      </div>
    </>
  );
}

export default Home;
